<div class="chain-dialog">
  <h3 class="dialog-title">{{ direction }}</h3>
  <div class="link-container">
    <ng-container *ngFor="let link of linkObjects | async">
      <div class="link">
        <a (click)="redirect(link.OBJECT_ID)">
          <img matListItemIcon [src]="link.ICON_URL" [alt]="link.ICON_URL" />
          <span>{{ link.TEXT }}</span>
        </a>
      </div>
    </ng-container>
  </div>

  <div class="cancel-button">
    <button mat-flat-button color="primary" (click)="cancel()">
      ABBRECHEN
    </button>
  </div>
</div>
